









import { Component, Vue } from "vue-property-decorator";
import AppHeader from "../../../views/AppHeader.vue";
import UserTaskList from "./UserTaskList.vue";

@Component({
  components: {
    AppHeader,
    UserTaskList
  }
})
export default class TaskPage extends Vue {}
